<template>
  <div class="version-info">
    <div class="shortcut-info"></div>
    <div class="detail-info">
      <canvas
        id="qrcode"
        class="qrcode"
      ></canvas>
      <div class="tip">{{$t('login.qrcode_tip')}}</div>
    </div>
  </div>
</template>

<script>
import Api from 'api/api'
import { ErrorHandleMixin } from 'utils/mixin'
import QRCode from 'qrcode'
export default {
  name: 'version-info',
  data () {
    return {
      activeInfo: ''
    }
  },
  watch: {
    activeInfo (value) {
      let canvas = document.getElementById('qrcode')
      QRCode.toCanvas(canvas, value, {
        width: 86,
        height: 86,
        margin: 0
      })
    }
  },
  methods: {
    getInfo () {
      Api.login.getActiveInfo().then(res => {
        this.activeInfo = res.data.activeInfo
      }).catch(this._handleError)
    }
  },
  mounted () {
    this.getInfo()
  },
  mixins: [ErrorHandleMixin]
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.version-info {
  position: relative;
  .shortcut-info {
    width: 42px;
    height: 46px;
    background: url("../../assets/images/Code.png");
  }
  .detail-info {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 142px;
    display: none;
    margin-bottom: 1px;
    margin-left: 1px;
    text-align: center;
    overflow: hidden;
    background: #fff;
    padding: 8px 12px;
    .qrcode {
      width: 86px;
      height: 86px;
      margin: 16px auto 6px;
    }
  }
  &:hover {
    .shortcut-info {
      display: none;
    }
    .detail-info {
      display: block;
    }
  }
}
</style>
